import { HttpClient } from '@angular/common/http';
import { Observable, catchError, of } from 'rxjs';
import { md5 } from 'js-md5';

export interface CrowdlConfig {
  projectId: string;
  apiKey: string;
  secret: string;
}

export class CrowdlSource {
  constructor(
    private http: HttpClient,
    private config: CrowdlConfig
  ) {}

  load(lang: string): Observable<any> {
    const timestamp = Date.now().toString();
    const hash = this.getHash(timestamp);

    return this.http.get(
      `https://api.crowdl.io/${this.config.projectId}/translations`,
      {
        params: {
          api_key: this.config.apiKey,
          timestamp,
          locale: lang,
          include_missing: false,
          format: 'hierarchical-json',
          hash,
        },
      }
    ).pipe(
      catchError(err => {
        console.error('Crowdl error', err);
        return of({});
      })
    );
  }

  private getHash(timestamp: string): string {
    return md5(timestamp + this.config.secret);
  }
}